import Vue from 'vue';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import ShopCheckoutApi from '../generated/api/ShopCheckout';

export default (service: Servicelayer) => ({
  ...ShopCheckoutApi(service),

  // Add custom calls here

});
